import React, { Component } from "react";

const style = {
  container: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    whiteSpace: "pre-line"
  }
};

export class ReadMoreContent extends Component {
  state = {
    readMore: false,
    atTop: true
  };

  constructor(props) {
    super(props);
    this.readMoreContainer = React.createRef();
    this.readMoreContentContainer = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ showReadMore: this.onShowReadMore() });
    }, 0);
    window.addEventListener("scroll", this.checkScroll);
    this.checkScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.checkScroll);
  }

  checkScroll = () => {
    const marginThreshold = 300;
    this.setState({ atTop: window.scrollY < marginThreshold });
  };

  onToggleReadMore = e => {
    let { shouldPreventDefault = false } = this.props;
    shouldPreventDefault && e.preventDefault();
    this.setState({
      readMore: !this.state.readMore
    });
  };

  onShowReadMore = () => {
    const { readMoreContainer, readMoreContentContainer } = this;
    const { content, isProjectMom } = this.props;
    let lines;
    if (readMoreContainer && readMoreContainer.current) {
      const containerHeight = readMoreContainer.current.clientHeight;

      // Get computed styles to retrieve the line height
      const style = window.getComputedStyle(readMoreContainer.current);
      const lineHeight = parseFloat(style.lineHeight);

      // Calculate the number of lines by dividing height by line height
      lines = Math.round(containerHeight / lineHeight);
    }

    const el = readMoreContainer.current;
    // console.log("el", el, el.scrollHeight, el.clientHeight);
    if (el && el.scrollHeight > el.clientHeight) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const {
      props: {
        clamp = 5,
        content = "",
        classes,
        Template,
        displayExpandButtons = true,
        displayOnProjectDetails,
        isProjectMom,
        fontweightcss
      },
      state: { readMore, showReadMore },
      onToggleReadMore,
      readMoreContainer,
      readMoreContentContainer
    } = this;

    const { atTop } = this.state;
    const { lineHeightTitle, descriptionWeight } = this.props;
    const isHindi =
      typeof content === "string" && /[\u0900-\u097F]/.test(content);
    const issueDetailP = window.location.pathname == "/issue-detail";
    const projectDetailP = window.location.pathname == "/detail-project";
    const expandClampValue = 9999;
    // return if content is not specified
    return (
      <div
        className={`read-more-container ${classes} ${
          displayOnProjectDetails ? "cursor-none" : ""
        }`}
        style={{
          paddingTop:
            isHindi &&
            window.location.pathname != "/agenda-details" &&
            !(projectDetailP || issueDetailP)
              ? "7px"
              : ""
        }}
      >
        <p
          ref={readMoreContainer}
          style={{
            ...style.container,
            WebkitLineClamp: readMore ? expandClampValue : clamp
          }}
          // className={`${
          //   typeof content === "string" && content.match(/[\u0900-\u097F]/)
          //     ? "clamp-none"
          //     : ""
          // }`}
        >
          <span
            ref={readMoreContentContainer}
            data-test="project-name-in-project-details"
            className={`${isHindi ? "hindi-text-wrap" : ""}`}
            style={{
              lineHeight:
                isHindi && lineHeightTitle == undefined
                  ? "1.5"
                  : isHindi && lineHeightTitle != undefined
                  ? "1.3"
                  : "",
              fontWeight:
                isHindi && descriptionWeight
                  ? 400
                  : (isHindi && issueDetailP && clamp == 2) ||
                    (isHindi && atTop && (projectDetailP || issueDetailP))
                  ? 400
                  : isHindi && window.location.pathname == "/issue-detail"
                  ? 400
                  : isHindi
                  ? 400
                  : ""
            }}
            dangerouslySetInnerHTML={{
              __html: content
            }}
          />
        </p>
        {showReadMore && displayExpandButtons ? (
          <span
            className="read-more-icon"
            style={{ fontWeight: fontweightcss ? 400 : null }}
            onClick={e => onToggleReadMore(e)}
          >
            {readMore ? "Read Less" : "Read More"}
          </span>
        ) : null}
      </div>
    );
  }
}
